// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:16:13

export default {
  "id": "one-hero",
  "slug": "one-hero",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1142533402a44be2bcd924340d026a62-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1142533402a44be2bcd924340d026a62/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "One HERO",
      "description": "One Hero: Dive into the ultimate action-packed shooting game! Play as a lone hero, dodging and shooting your way through waves of enemies. Eliminate all foes to claim victory. Are you ready to be the last one standing?\nDive into a thrilling, action-packed adventure where you’ll face waves of enemies and intense boss battles.\nWith intuitive controls and accessible gameplay, players of all skill levels can jump in and start unleashing chaos in no time.",
      "instructions": "touchpad and arrow for pc ",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "hero",
        "shopping",
        "superhero",
        "survival"
      ]
    },
    "zh-CN": {
      "title": "一位英雄",
      "description": "一英雄：深入终极动作射击游戏！扮演一位孤独的英雄，躲避敌人并射击，冲破敌阵。消灭所有敌人以获得胜利。你准备好成为最后的幸存者了吗？\n投身于一场激动人心的动作冒险，你将面对一波又一波的敌人以及紧张的Boss战。\n拥有直观的操作和易上手的游戏性，不同技能水平的玩家都能轻松加入，瞬间开始释放混乱。",
      "instructions": "触摸板和箭头键（适用于PC）",
      "genres": [
        "射击游戏"
      ],
      "tags": [
        "英雄",
        "购物",
        "超级英雄",
        "生存"
      ]
    },
    "zh-TW": {
      "title": "一個英雄",
      "description": "一英雄：躍入終極動作砲戰遊戲！扮演單一英雄，避開敵人攻擊並射擊，一路衝破敵人浪潮。消滅所有敵人，奪得勝利。你準備好成為最後的生存者了嗎？\n躍入一場刺激的動作冒險，你將面對一波又一波的敵人和激烈的BOSS戰。\n擁有直觀的操作和易於上手的遊戲性，所有技能等級的玩家都能迅速加入遊戲，展開混亂的攻擊。",
      "instructions": "觸控板及方向鍵用於電腦",
      "genres": [
        "射手"
      ],
      "tags": [
        "英雄",
        "購物",
        "超級英雄",
        "生存"
      ]
    },
    "zh-HK": {
      "title": "一英雄",
      "description": "一英雄：躍入終極動作充滿的射擊遊戲！扮演獨行俠，避開敵人並射擊，穿過一波又一波的敵人。消滅所有敵人以獲得勝利。你準備成為最後的存倖者了嗎？\n躍入一場驚險、動作充滿的冒險中，你將面對一波又一波的敵人和激烈的BOSS戰鬥。\n簡單直觀的操作和易於上手的遊戲性，所有技能水平的玩家都能立刻投入遊戲，無需多花時間就能開展混沌。",
      "instructions": "觸控板及方向鍵用於電腦",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "英雄",
        "購物",
        "超級英雄",
        "生存"
      ]
    },
    "ja": {
      "title": "一英雄",
      "description": "一英雄：究極のアクション満載のシューティングゲームに潜り込もう！孤独のヒーローとして、敵の波を避けながら銃撃を当てて進んでいこう。全ての敵を倒して勝利を手に入れよう。最後まで生き残れる準備はできていますか？\n波打ち際の興奮とアクションに満ちた冒険に潜り込み、敵の波と激しいボスバトルに挑戦しよう。\n直感的な操作とアクセスしやすいゲームプレイで、どんなスキルレベルのプレイヤーもすぐにカaosを放つことができます。",
      "instructions": "タッチパッドとアーロウキー（PC用）",
      "genres": [
        "シューティングゲーム"
      ],
      "tags": [
        "ヒーロー",
        "ショッピング",
        "スーパーヒーロー",
        "サバイバル"
      ]
    },
    "ko": {
      "title": "한 HERO",
      "description": "원 Heroes: 최상급 액션 패키지 쏘기 게임에 뛰어들세요! 단신의 영웅으로서 적들을 피하며 쏘아 내리는 중 거의 적들을 통쾌히 물리치세요. 모든 적들을 제거하여 승리를 석권하세요. 마지막 남은 사람이 되어볼 준비가 되나요?\n적들의 대움대를 맞고 치열한 보스전을 겪는 흥미진진한 액션 어드벤처에 뛰어들세요.\n직관적인 조종과 접근 가능한 게임 플레이로, 모든 기술 수준의 플레이어들이 즉시 치욕을 풀기 시작할 수 있습니다.",
      "instructions": "터치패드와 아로우 키(PC)",
      "genres": [
        "총알쏘기 게임"
      ],
      "tags": [
        "영웅",
        "쇼핑",
        "슈퍼히어로",
        "생존"
      ]
    },
    "fr": {
      "title": "Un HÉROS",
      "description": "Un Héros : Plongez dans le jeu de tir actionné ultime ! Jouez en tant que héros solitaire, évitant et tirant votre chemin à travers des vagues d'ennemis. Éliminez tous les ennemis pour revendiquer la victoire. Êtes-vous prêt à être le dernier debout ?\nPlongez dans une aventure palpitante, actionnée, où vous affronterez des vagues d'ennemis et des combats de boss intenses.\nAvec des commandes intuitives et un gameplay accessible, les joueurs de tous niveaux de compétences peuvent entrer en jeu et commencer à semer le chaos en un rien de temps.",
      "instructions": "pavé tactile et flèches pour PC",
      "genres": [
        "Tirailleur"
      ],
      "tags": [
        "héros",
        "shopping",
        "super-héros",
        "survie"
      ]
    }
  }
};
